module.exports = __webpack_public_path__ + "img/logo10.c940e75e.png";